import React from 'react';
import { t } from 'i18next';
import { Trans } from 'react-i18next';
import { EventNames, EventTypes, trackEvent } from '@brighterion/insights';
import useReduxModal from 'Hooks/reduxHelperHooks/useReduxModal';
import useCancelImportExportList from 'Hooks/query-hooks/side-panel/useCancelImportExportList';
import { IMPORT_EXPORT_PROCESS_TYPE, IMPORT_EXPORT_STATUS } from 'Common/enums';

const useHandleImportExportProcessCancel = () => {
    const { addModal } = useReduxModal();
    const mutation = useCancelImportExportList({});

    const confirmCancelModal = React.useCallback((cancellationProps: CancelImportExportProcess) => {
        const id = cancellationProps?.id;
        const isImport = cancellationProps?.type === IMPORT_EXPORT_PROCESS_TYPE.IMPORT;
        const isImportAndInProgress = isImport && cancellationProps?.status === IMPORT_EXPORT_STATUS.IN_PROGRESS;
        const action = isImport ? t('Import entries from CSV') : t('Export all entries to CSV');
        const transKey = isImport ? 'Confirm Cancel Import List' : 'Confirm Cancel Export List';
        const listName = cancellationProps?.listName;
        const title = isImport ? t('Cancel Import') : t('Cancel Export');
        const type = cancellationProps?.type;

        const handleOnAction = () => {
            const trackEventData = isImport
                ? 'Queue - Cancel Import List Entries'
                : 'Queue - Cancel Export List Entries';
            trackEvent({
                eventType: EventTypes.track,
                eventName: EventNames.click,
                payload: {
                    clickIdentifier: trackEventData,

                    text: trackEventData
                }
            });
            mutation.mutate({ id, type: type.toLowerCase() });
        };

        addModal({
            id: 'import-export-cancellation-modal',
            status: 'warning',
            title,
            content: (
                <div>
                    <Trans i18nKey={transKey}>
                        {{ action }} {{ listName }}
                    </Trans>
                    {t('This action cannot be undone')}
                    {isImportAndInProgress && (
                        <>
                            <br />
                            <br />
                            {t('List Import Cancellation Dialog')}
                        </>
                    )}
                </div>
            ),
            onAction: handleOnAction,
            onActionText: t('Confirm Cancellation'),
            cancelText: t('Cancel')
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { confirmCancelModal };
};

export default useHandleImportExportProcessCancel;
